module.exports = __webpack_public_path__ + "img/badge_googleplay@3x.afc478c9.png";